import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit, forwardRef } from '@angular/core';
import { UntypedFormBuilder, FormGroup, UntypedFormControl, Validators, ValidatorFn, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MessageService } from 'base';
import { ConfigurationService } from '../../services/configuration.service';
import { OnDestroy } from '@angular/core';
import { ComponentBase } from 'common';
import { StringUtils } from 'DiscoveryEngine.TS/Utils';
import { Integration, IntegrationNames, IntegrationTable } from '../../../DiscoveryEngine.TS/Core/Integration';
import { DefaultIntegrationSettingsChild } from '../default-integration-settings-child-interface/default-integration-settings-child-interface';


@Component({
	selector: 'slack-default-settings',
	templateUrl: './slack-default-settings.component.html',
	styleUrls: ['./slack-default-settings.component.scss']
})
export class SlackDefaultSettingsComponent extends ComponentBase implements DefaultIntegrationSettingsChild, OnInit, OnDestroy, OnChanges {
	@Input()
	public inputSettings: Integration;

	public form: UntypedFormGroup;

	public webhooks: UntypedFormControl;

	constructor(private fb: UntypedFormBuilder,
		private configService: ConfigurationService,
		private messageService: MessageService) {

		super();
	}

	public ngOnInit(): void {
		this.buildForm();
	}

	public ngOnDestroy(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.buildForm();
	}

	private buildForm(): void {
		this.webhooks = undefined;

		let enabled = true;
		let webhooks = "";

		// Load in the settings from the input settings variable, and set them to the form controls.
		if (this.inputSettings) {
			enabled = this.inputSettings.Enabled;
			webhooks = this.inputSettings.Webhooks;
		}

		this.webhooks = new UntypedFormControl(webhooks);

		this.form = this.fb.group({
			webhooks: this.webhooks,
		},
		{
			validator: Validators.compose([
				this.noneOrAllSettings(),
			])
		});
	}

	public enableSave(): boolean {
		return !this.form.invalid;
	}

	public onSave(): void {
		const outputIntegrationTable = new IntegrationTable();
		const integrationSettings = this.getIntegrationSettings();
		outputIntegrationTable.Add(integrationSettings);
		this.configService.setIntegrationTable(outputIntegrationTable).subscribe(
			() => {
				this.messageService.displayInfoMessage("Successfully saved Slack default settings");
				this.form.markAsPristine();
			},
			(error) => {
				this.messageService.displayErrorMessage("Failed to save Slack default settings");
			});
	}

	public get enableTestSlackButton(): boolean {
		return (!!this.webhooks && !!this.webhooks.value);
	}

	public testConnection(): void {
		this.configService.testSlackConnection(this.webhooks.value).subscribe(
			() => {
				this.messageService.displayInfoMessage("Successfully sent message to all channel webhooks.");
			},
			(error) => {
				this.messageService.displayErrorMessage(error);
			});
	}

	public getIntegrationSettings(): Integration {
		const outputIntegration = new Integration(IntegrationNames.Slack);
		outputIntegration.Webhooks = this.webhooks.value;
		return outputIntegration;
	}

	private noneOrAllSettings(): ValidatorFn {
		return () => {
			if (!!this.webhooks.value) {
				return {
					noneOrAllSettings: { valid: false }
				};
			}

			return null;
		}
	}

}
